import { render, staticRenderFns } from "./DeviceManagement.vue?vue&type=template&id=510aefcd&scoped=true"
import script from "./DeviceManagement.vue?vue&type=script&lang=js"
export * from "./DeviceManagement.vue?vue&type=script&lang=js"
import style0 from "./DeviceManagement.vue?vue&type=style&index=0&id=510aefcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510aefcd",
  null
  
)

export default component.exports